import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    // 首页
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '首页', icon: 'el-icon-news', affix: true, keepAlive: true }
      }
    ]
  },
  {
    // 登录页
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }

  // {
  //   path: "/system",
  //   component: Layout,
  //   redirect: "/system",
  //   name: "系统管理",
  //   meta: { title: "系统管理" },
  //   children: [
  //     {
  //       path: "admin",
  //       name: "管理员管理",
  //       component: () => import("@/views/system/admin"),
  //       meta: { title: "管理员管理" },
  //     },
  //     {
  //       path: "role",
  //       name: "角色分配",
  //       component: () => import("@/views/system/role"),
  //       meta: { title: "角色分配" },
  //     },
  //     {
  //       path: "global",
  //       name: "新全局变量",
  //       component: () => import("@/views/system/global"),
  //       meta: { title: "新全局变量" },
  //     },
  //     {
  //       path: "emty",
  //       name: "通用内容",
  //       component: () => import("@/views/system/emty"),
  //       meta: { title: "通用内容" },
  //     },
  //     {
  //       path: "android",
  //       name: "安卓版本管理",
  //       component: () => import("@/views/system/android"),
  //       meta: { title: "安卓版本管理" },
  //     },
  //   ],
  // },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // 访问统计
  // {
  //   // 访问统计
  //   path: '/statData',
  //   component: Layout,
  //   redirect: '/statData',
  //   meta: { title: '访问统计', icon: 'el-icon-setting' },
  //   children: [
      
  //   ]
  // },
  {
    // 首页
    path: '/statistics',
    component: Layout,
    redirect: '/statistics',
    meta: { title: '数据统计', icon: 'el-icon-setting' },
    children: [
      {
        path: '/statistics',
        component: () => import('@/views/statistics/statistics'),
        name: 'statistics',
        meta: {
          title: '数据统计',
          roles: ['admin:data'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: false
        }
      }
    ]
  },
  
    // 消息
  {
    path: '/message',
    component: Layout,
    redirect: '/',
    name: '消息通知',
    meta: { title: '消息通知', icon: 'el-icon-setting' },
    children: [
      {
        path: '/system',
        component: () => import('@/views/message/system'),
        name: 'system',
        meta: {
          title: '系统消息',
          roles: ['admin:message1'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/personal',
        component: () => import('@/views/message/personal'),
        name: 'personal',
        meta: {
          title: '个人消息',
          roles: ['admin:message2'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      }
    ]
  },
  
    // 消息
    {
      path: '/operate',
      component: Layout,
      redirect: '/',
      name: '运营管理',
      meta: { title: '运营管理', icon: 'el-icon-setting' },
      children: [
        {
          path: '/yifang',
          component: () => import('@/views/operate/yifang'),
          name: 'yifang',
          meta: {
            title: '代理商管理',
            roles: ['admin:yifang'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/yifangDate',
          component: () => import('@/views/operate/yifangDate'),
          name: 'yifangDate',
          meta: {
            title: '代理商数据',
            roles: ['admin:yifangData'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/member',
          component: () => import('@/views/operate/member'),
          name: 'member',
          meta: {
            title: '用户管理',
            roles: ['admin:member'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        // {
        //   path: '/operate/vipConfig',
        //   component: () => import('@/views/operate/vipConfig'),
        //   name: 'member',
        //   meta: {
        //     title: 'VIP配置',
        //     roles: ['admin:vipConfig'],
        //     icon: 'icon-guanliyuan',
        //     info: '后台管理员管理',
        //     keepAlive: true
        //   }
        // },
        // {
        //   path: '/operate/memberVipAward',
        //   component: () => import('@/views/operate/memberVipAward'),
        //   name: 'member',
        //   meta: {
        //     title: 'VIP奖金记录',
        //     roles: ['admin:memberVipAward'],
        //     icon: 'icon-guanliyuan',
        //     info: '后台管理员管理',
        //     keepAlive: true
        //   }
        // },
        {
          path: '/commonContent',
          component: () => import('@/views/operate/commonContent'),
          name: 'commonContent',
          meta: {
            title: '通用配置内容',
            roles: ['admin:commonContent'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/operate/ticket',
          component: () => import('@/views/operate/ticket'),
          name: 'ticket',
          meta: {
            title: '币种管理',
            roles: ['admin:ticket'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/operate/tradeTicket',
          component: () => import('@/views/operate/tradeTicket'),
          name: 'tradeTicket',
          meta: {
            title: '交易币种管理',
            roles: ['admin:tradeTicket'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/tronscanTransfers',
          component: () => import('@/views/operate/tronscanTransfer'),
          name: 'tronscanTransfers',
          meta: {
            title: 'USDT充值记录',
            roles: ['admin:tronscanTransfer'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        // { 
        //   path: '/tronscanTransferTrx',
        //   component: () => import('@/views/operate/tronscanTransferTrx'),
        //   name: 'tronscanTransferTrx',
        //   meta: {
        //     title: 'TRX充值记录',
        //     roles: ['admin:tronscanTransferTrx'],
        //     icon: 'icon-guanliyuan',
        //     info: '后台管理员管理',
        //     keepAlive: true
        //   }
        // },
        {
          path: '/tronscanTransferOther',
          component: () => import('@/views/operate/tronscanTransferOther'),
          name: 'tronscanTransferOther',
          meta: {
            title: '其他币种充值记录', 
            roles: ['admin:tronscanTransferOther'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/withdrawRecord',
          component: () => import('@/views/operate/withdrawRecord'),
          name: 'withdrawRecord',
          meta: {
            title: 'USDT提现记录',
            roles: ['admin:withdrawRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        // {
        //   path: '/withdrawRecordTrx',
        //   component: () => import('@/views/operate/withdrawRecordTrx'),
        //   name: 'withdrawRecordTrx',
        //   meta: {
        //     title: 'TRX提现记录',
        //     roles: ['admin:withdrawRecordTrx'],
        //     icon: 'icon-guanliyuan',
        //     info: '后台管理员管理',
        //     keepAlive: true
        //   }
        // },
        {
          path: '/memberAmountRecord',
          component: () => import('@/views/operate/memberAmountRecord'),
          name: 'memberAmountRecord',
          meta: {
            title: '流水明细',
            roles: ['admin:memberAmountRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        
        {
          path: '/banner',
          component: () => import('@/views/operate/banner'),
          name: 'banner',
          meta: {
            title: '轮播图',
            roles: ['admin:banner'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/operate/memberExchangeRecord',
          component: () => import('@/views/operate/memberExchangeRecord'),
          name: 'memberExchangeRecord',
          meta: {
            title: '闪兑记录',
            roles: ['admin:memberExchangeRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/operate/signConfig',
          component: () => import('@/views/operate/signConfig'),
          name: 'signConfig',
          meta: {
            title: '签到配置',
            roles: ['admin:signConfig'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/operate/memberTradeCoinRecord',
          component: () => import('@/views/operate/memberTradeCoinRecord'),
          name: 'memberTradeCoinRecord',
          meta: {
            title: '涨跌兑换记录',
            roles: ['admin:memberTradeCoinRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/operate/drawConfig',
          component: () => import('@/views/operate/drawConfig'),
          name: 'drawConfig',
          meta: {
            title: '抽奖设置(弃用)',
            roles: ['admin:drawConfig'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/shareConfig',
          component: () => import('@/views/operate/shareConfig'),
          name: 'shareConfig',
          meta: {
            title: '分享配置',
            roles: ['admin:shareConfig'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/ywWithdrawRecord',
          component: () => import('@/views/operate/ywWithdrawRecord'),
          name: 'ywWithdrawRecord',
          meta: {
            title: '业务员提现记录',
            roles: ['admin:ywWithdrawRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/memberPaa',
          component: () => import('@/views/operate/memberPaa'),
          name: 'memberPaa',
          meta: {
            title: '好友助力记录',
            roles: ['admin:memberPaa'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/memberShareRecord',
          component: () => import('@/views/operate/memberShareRecord'),
          name: 'memberShareRecord',
          meta: {
            title: '发帖记录',
            roles: ['admin:memberShareRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/memberShareWithdrawBnb',
          component: () => import('@/views/operate/memberShareWithdrawBnb'),
          name: 'memberShareWithdrawBnb',
          meta: {
            title: '发帖提现记录(币安)',
            roles: ['admin:memberShareWithdrawBnb'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/memberShareWithdrawTrx',
          component: () => import('@/views/operate/memberShareWithdrawTrx'),
          name: 'memberShareWithdrawTrx',
          meta: {
            title: '发帖提现记录(波场)',
            roles: ['admin:memberShareWithdrawTrx'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        // {
        //   path: '/memberMeetingRecord',
        //   component: () => import('@/views/operate/memberMeetingRecord'),
        //   name: 'memberMeetingRecord',
        //   meta: {
        //     title: '会议记录',
        //     roles: ['admin:memberMeetingRecord'],
        //     icon: 'icon-guanliyuan',
        //     info: '后台管理员管理',
        //     keepAlive: true
        //   }
        // },
        {
          path: '/coupon',
          component: () => import('@/views/operate/coupon'),
          name: 'coupon',
          meta: {
            title: '充值优惠券配置',
            roles: ['admin:coupon'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/memberSubsidy',
          component: () => import('@/views/operate/memberSubsidy'),
          name: 'memberSubsidy',
          meta: {
            title: '每周补贴打卡记录',
            roles: ['admin:memberSubsidy'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/teamLevelConfig',
          component: () => import('@/views/operate/teamLevelConfig'),
          name: 'teamLevelConfig',
          meta: {
            title: '团队等级管理',
            roles: ['admin:teamLevelConfig'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        }
        // {
        //   path: '/operate/entranceConfig',
        //   component: () => import('@/views/operate/entranceConfig'),
        //   name: 'entranceConfig',
        //   meta: {
        //     title: '入口管理',
        //     roles: ['admin:entranceConfig'],
        //     icon: 'icon-guanliyuan',
        //     info: '后台管理员管理',
        //     keepAlive: true
        //   }
        // }
      ]
    },
   // 空投包
   {
    path: '/airdrop',
    component: Layout,
    redirect: '/',
    name: '空投包',
    meta: { title: '空投包', icon: 'el-icon-setting' },
    children: [
      {
        path: '/airdrop/airdropPackage',
        component: () => import('@/views/airdrop/airdropPackage'),
        name: 'airdropPackage',
        meta: {
          title: '升级包管理',
          roles: ['admin:airdropPackage'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      { 
        path: '/airdrop/airdropBuyRecord',
        component: () => import('@/views/airdrop/airdropBuyRecord.vue'),
        name: 'airdropBuyRecord',
        meta: {
          title: '购买记录',
          roles: ['admin:airdropBuyRecord'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/airdrop/airdropReceiveRecord',
        component: () => import('@/views/airdrop/airdropReceiveRecord'),
        name: 'airdropReceiveRecord',
        meta: {
          title: '领取记录',
          roles: ['admin:airdropReceiveRecord'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/airdrop/airdropSaleRecord',
        component: () => import('@/views/airdrop/airdropSaleRecord'),
        name: 'airdropSaleRecord',
        meta: {
          title: '赎回记录(弃用)',
          roles: ['admin:airdropSaleRecord'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
     
    ]
  },
  // c2c
  {
    path: '/c2c',
    component: Layout,
    redirect: '/',
    name: 'C2C',
    meta: { title: 'C2C', icon: 'el-icon-setting' },
    children: [
      {
        path: '/c2c/ccSale',
        component: () => import('@/views/c2c/ccSale'),
        name: 'ccSale',
        meta: {
          title: '出售管理',
          roles: ['admin:ccSale'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      { 
        path: '/c2c/ccBuyRecord',
        component: () => import('@/views/c2c/ccBuyRecord.vue'),
        name: 'ccBuyRecord',
        meta: {
          title: '购买记录',
          roles: ['admin:ccBuyRecord'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/c2c/ccMemberVerification',
        component: () => import('@/views/c2c/ccMemberVerification'),
        name: 'ccMemberVerification',
        meta: {
          title: '认证管理',
          roles: ['admin:ccMemberVerification'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/c2c/ccMemberBehavior',
        component: () => import('@/views/c2c/ccMemberBehavior'),
        name: 'ccMemberBehavior',
        meta: {
          title: '行为统计',
          roles: ['admin:ccMemberBehavior'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/c2c/ccPaymentMethod',
        component: () => import('@/views/c2c/ccPaymentMethod'),
        name: 'ccPaymentMethod',
        meta: {
          title: '法币收款方式',
          roles: ['admin:ccPaymentMethod'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/tfData',
    component: Layout,
    redirect: '/',
    name: '访问管理',
    meta: { title: '访问管理', icon: 'el-icon-setting' },
    children: [
      {
          path: '/statData',
          component: () => import('@/views/statData/statData'),
          name: 'statData',
          meta: {
            title: '访问统计',
            roles: ['admin:statData1'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: false
          }
        },
      { 
        path: '/tfData/adDomainData',
        component: () => import('@/views/tfData/adDomainData'),
        name: 'adDomainData',
        meta: {
          title: '域名访问统计',
          roles: ['admin:adDomainData'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      }
    ]
  },
  // 现货交易
  // {
  //   path: '/trade',
  //   component: Layout,
  //   redirect: '/',
  //   name: '现货交易',
  //   meta: { title: '现货交易', icon: 'el-icon-setting' },
  //   children: [
  //     {
  //       path: '/trade/tradeRecord',
  //       component: () => import('@/views/trade/tradeRecord'),
  //       name: 'tradeRecord',
  //       meta: {
  //         title: '历史期号',
  //         roles: ['admin:tradeRecord'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //     {
  //       path: '/trade/tradeBuyRecord',
  //       component: () => import('@/views/trade/tradeBuyRecord'),
  //       name: 'tradeBuyRecord',
  //       meta: {
  //         title: '购买记录',
  //         roles: ['admin:tradeBuyRecord'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //     {
  //       path: '/trade/tradeBuyRecordT',
  //       component: () => import('@/views/trade/tradeBuyRecordT'),
  //       name: 'tradeBuyRecordSum',
  //       meta: {
  //         title: '购买统计',
  //         roles: ['admin:tradeBuyRecordSum'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //     {
  //       path: '/trade/tradeTicket',
  //       component: () => import('@/views/trade/tradeTicket'),
  //       name: 'tradeTicket',
  //       meta: {
  //         title: '币种管理',
  //         roles: ['admin:tradeTicket'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
     
  //   ]
  // },
   // 智能交易
  //  {
  //   path: '/expertAdvisor',
  //   component: Layout,
  //   redirect: '/',
  //   name: '智能交易',
  //   meta: { title: '智能交易', icon: 'el-icon-setting' },
  //   children: [
  //     {
  //       path: '/expertAdvisor/intelTicket',
  //       component: () => import('@/views/expertAdvisor/intelTicket'),
  //       name: 'intelTicket',
  //       meta: {
  //         title: '币种',
  //         roles: ['admin:intelTicket'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //     { 
  //       path: '/expertAdvisor/intelBuyRecord',
  //       component: () => import('@/views/expertAdvisor/intelBuyRecord.vue'),
  //       name: 'intelBuyRecord',
  //       meta: {
  //         title: '交易记录',
  //         roles: ['admin:intelBuyRecord'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //     {
  //       path: '/expertAdvisor/intelMemberAccount',
  //       component: () => import('@/views/expertAdvisor/intelMemberAccount'),
  //       name: 'intelMemberAccount',
  //       meta: {
  //         title: '用户持有量',
  //         roles: ['admin:intelMemberAccount'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
     
  //   ]
  // },
    // 投资管理 
    {
      path: '/investment',
      component: Layout,
      redirect: '/',  
      name: '投资管理',
      meta: { title: '投资管理', icon: 'el-icon-setting' },
      children: [
        {
          path: '/investData',
          component: () => import('@/views/investment/investData'),
          name: 'investData',
          meta: {
            title: '投资数据',
            roles: ['admin:investData'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/invest',
          component: () => import('@/views/investment/invest'),
          name: 'invest',
          meta: {
            title: '投资管理',
            roles: ['admin:invest'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        },
        {
          path: '/investRecord',
          component: () => import('@/views/investment/investRecord'),
          name: 'investRecord',
          meta: {
            title: '投资记录',
            roles: ['admin:investRecord'],
            icon: 'icon-guanliyuan',
            info: '后台管理员管理',
            keepAlive: true
          }
        }
      ]
    },


  // 内容管理
  {
    path: '/content',
    component: Layout,
    redirect: '/',
    name: '内容管理',
    meta: { title: '内容管理', icon: 'el-icon-setting' },
    children: [
      {
        path: '/content/commonNews',
        component: () => import('@/views/content/commonNews'),
        name: 'commonNews',
        meta: {
          title: '社区管理',
          roles: ['admin:commonNews'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      // {
      //   path: '/content/commonAnnou',
      //   component: () => import('@/views/content/commonAnnou'),
      //   name: 'commonAnnou',
      //   meta: {
      //     title: '公告管理',
      //     roles: ['admin:commonAnnou'],
      //     icon: 'icon-guanliyuan',
      //     info: '后台管理员管理',
      //     keepAlive: true
      //   }
      // },
      {
        path: '/content/commonStudy',
        component: () => import('@/views/content/commonStudy'),
        name: 'commonStudy',
        meta: {
          title: '成长学院',
          roles: ['admin:commonStudy'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
    ]
  },
  
 
    // 消息
  // {
  //   path: '/share',
  //   component: Layout,
  //   redirect: '/',
  //   name: '广告分享',
  //   meta: { title: '广告分享', icon: 'el-icon-setting' },
  //   children: [
  //     {
  //       path: '/share/tieImage',
  //       component: () => import('@/views/share/tieImage'),
  //       name: 'tieImage',
  //       meta: {
  //         title: '广告素材配置',
  //         roles: ['admin:tieImage'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     }, 
  //     {
  //       path: '/share/memberTie',
  //       component: () => import('@/views/share/memberTie'),
  //       name: 'memberTie',
  //       meta: {
  //         title: '分享朋友圈记录',
  //         roles: ['admin:memberTie'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //     {
  //       path: '/share/memberPayAd',
  //       component: () => import('@/views/share/memberPayAd'),
  //       name: 'memberTie',
  //       meta: {
  //         title: '付费推广记录',
  //         roles: ['admin:memberPayAd'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: true
  //       }
  //     },
  //   ]
  // },
   
 
  // 系统设置
  {
    path: '/setting',
    component: Layout,
    redirect: '/',
    name: '系统设置',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      {
        // 管理员管理
        path: '/setting/manangement',
        component: () => import('@/views/setting/management'),
        name: 'Management',
        meta: {
          title: '管理员管理',
          roles: ['admin:admin'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        // 角色分配
        path: '/setting/role',
        component: () => import('@/views/setting/roleManagement'),
        name: 'RoleManagement',
        meta: {
          title: '角色分配',
          roles: ['admin:role'],
          icon: 'icon-jiaosequanxian',
          info: '角色分配管理',
          keepAlive: true
        }
      },
      {
        // 新全局参数
        path: '/setting/globalNewParams',
        component: () => import('@/views/setting/globalNewParams'),
        name: 'globalNewParams',
        meta: {
          title: '全局参数',
          roles: ['admin:systemConfig'],
          icon: 'icon-quanju_yuming',
          info: '全局参数',
          keepAlive: true
        }
      },
      {
        // 新全局参数
        path: '/setting/Classification',
        component: () => import('@/views/setting/Classification'),
        name: 'Classification',
        meta: {
          title: '全局参数(分类)',
          roles: ['admin:systemConfig'],
          icon: 'icon-quanju_yuming',
          info: '全局参数分类',
          keepAlive: true
        }
      },
      {
        // 用户端安卓版本
        path: '/setting/userAndroidVersion',
        component: () => import('@/views/setting/userAndroidVersion'),
        name: 'userAndroidVersion',
        meta: {
          title: '安卓版本管理',
          roles: ['admin:versionAndroid'],
          keepAlive: true
        }
      }
    ]
  },
  // 资金管理
  {
    path: '/capital',
    component: Layout,
    redirect: '/',
    name: '资金管理(波场)',
    meta: { title: '资金管理(波场)', icon: 'el-icon-setting' },
    children: [
      {
        path: '/tronscanMasterAccount',
        component: () => import('@/views/capital/tronscanMasterAccount'),
        name: 'tronscanMasterAccount',
        meta: {
          title: '归集账号管理',
          roles: ['admin:tronscanMasterAccount'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/memberCollection',
        component: () => import('@/views/capital/memberCollection'),
        name: 'memberCollection',
        meta: {
          title: '用户资金管理',
          roles: ['admin:memberCollection'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/withdrawTransfer',
        component: () => import('@/views/capital/withdrawTransfer'),
        name: 'withdrawTransfer',
        meta: {
          title: 'USDT提现转账',
          roles: ['admin:withdrawTransfer'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      // {
      //   path: '/withdrawTransferTrx',
      //   component: () => import('@/views/capital/withdrawTransferTrx'),
      //   name: 'withdrawTransferTrx',
      //   meta: {
      //     title: 'TRX提现转账',
      //     roles: ['admin:withdrawTransferTrx'],
      //     icon: 'icon-guanliyuan',
      //     info: '后台管理员管理',
      //     keepAlive: true
      //   }
      // },
      {
        path: '/tronscanTransfer',
        component: () => import('@/views/capital/tronscanTransfer'),
        name: 'tronscanTransfer',
        meta: {
          title: 'USDT转账记录',
          roles: ['admin:tronscanZhuan'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      // {
      //   path: '/tronscanZhuanWithdrawTrx',
      //   component: () => import('@/views/capital/tronscanZhuanWithdrawTrx'),
      //   name: 'tronscanZhuanWithdrawTrx',
      //   meta: {
      //     title: 'TRX转账记录',
      //     roles: ['admin:tronscanZhuanWithdrawTrx'],
      //     icon: 'icon-guanliyuan',
      //     info: '后台管理员管理',
      //     keepAlive: true
      //   }
      // },
      {
        path: '/tronscanCollection',
        component: () => import('@/views/capital/tronscanCollection'),
        name: 'tronscanCollection',
        meta: {
          title: '归集记录',
          roles: ['admin:tronscanCollection'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      }
    ]
  },
  // 资金管理（币安）
  {
    path: '/binance',
    component: Layout,
    redirect: '/',
    name: '资金管理(币安)',
    meta: { title: '资金管理(币安)', icon: 'el-icon-setting' },
    children: [
      {
        path: '/binance/tronscanMasterAccount',
        component: () => import('@/views/binance/tronscanMasterAccount'),
        name: 'bnbMasterAccount',
        meta: {
          title: '币安主账号',
          roles: ['admin:bnbMasterAccount'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/binance/memberCollection',
        component: () => import('@/views/binance/memberCollection'),
        name: 'memberCollectionBnb',
        meta: {
          title: '用户资金管理',
          roles: ['admin:memberCollectionBnb'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/binance/withdrawTransfer',
        component: () => import('@/views/binance/withdrawTransfer'),
        name: 'withdrawTransferBnb',
        meta: {
          title: 'USDT提现转账',
          roles: ['admin:withdrawTransferBnb'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/binance/tronscanTransfer',
        component: () => import('@/views/binance/tronscanTransfer'),
        name: 'bnbZhuanUsdt',
        meta: {
          title: 'USDT转账记录',
          roles: ['admin:bnbZhuanUsdt'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/binance/tronscanCollection',
        component: () => import('@/views/binance/tronscanCollection'),
        name: 'bnbCollectionUsdt',
        meta: {
          title: 'USDT归集记录',
          roles: ['admin:bnbCollectionUsdt'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/binance/bnbCollectionTrx',
        component: () => import('@/views/binance/bnbCollectionTrx'),
        name: 'bnbCollectionUsdt',
        meta: {
          title: 'TRX归集记录',
          roles: ['admin:bnbCollectionTrx'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/binance/bnbCollectionOther',
        component: () => import('@/views/binance/bnbCollectionOther'),
        name: 'bnbCollectionOther',
        meta: {
          title: '其他币种归集记录',
          roles: ['admin:bnbCollectionOther'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      }
    ]
  }, 
  // 资金管理（以太坊）
  {
    path: '/ethMaster',
    component: Layout,
    redirect: '/',
    name: '资金管理(以太坊)',
    meta: { title: '资金管理(以太坊)', icon: 'el-icon-setting' },
    children: [
      {
        path: '/ethMaster/tronscanMasterAccount',
        component: () => import('@/views/ethMaster/tronscanMasterAccount'),
        name: 'ethMasterAccount',
        meta: {
          title: '以太坊主账号',
          roles: ['admin:ethMasterAccount'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/ethMaster/memberCollection',
        component: () => import('@/views/ethMaster/memberCollection'),
        name: 'memberCollectionEth',
        meta: {
          title: '用户资金管理',
          roles: ['admin:memberCollectionEth'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/ethMaster/withdrawTransfer',
        component: () => import('@/views/ethMaster/withdrawTransfer'),
        name: 'withdrawTransferBnb',
        meta: {
          title: 'USDT提现转账',
          roles: ['admin:withdrawTransferBnb'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/ethMaster/tronscanTransfer',
        component: () => import('@/views/ethMaster/tronscanTransfer'),
        name: 'bnbZhuanUsdt',
        meta: {
          title: 'USDT转账记录',
          roles: ['admin:bnbZhuanUsdt'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/ethMaster/tronscanCollection',
        component: () => import('@/views/ethMaster/tronscanCollection'),
        name: 'ethCollectionUsdt',
        meta: {
          title: 'USDT归集记录',
          roles: ['admin:ethCollectionUsdt'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/ethMaster/ethCollectionTrx',
        component: () => import('@/views/ethMaster/bnbCollectionTrx'),
        name: 'ethCollectionEth',
        meta: {
          title: 'ETH归集记录',
          roles: ['admin:ethCollectionEth'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/ethMaster/ethCollectionOther',
        component: () => import('@/views/ethMaster/bnbCollectionOther'),
        name: 'ethCollectionOther',
        meta: {
          title: '其他币种归集记录',
          roles: ['admin:ethCollectionOther'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      }
    ]
  }, 
  {
    path: '/Polygon',
    component: Layout,
    redirect: '/',
    name: '资金管理(Polygon)',
    meta: { title: '资金管理(Polygon)', icon: 'el-icon-setting' },
    children: [
      {
        path: '/Polygon/polMasterAccount',
        component: () => import('@/views/Polygon/polMasterAccount'),
        name: 'polMasterAccount',
        meta: {
          title: 'POL主账号',
          roles: ['admin:polMasterAccount'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/Polygon/memberCollectionPol',
        component: () => import('@/views/Polygon/memberCollectionPol'),
        name: 'memberCollectionPol',
        meta: {
          title: '用户资金管理',
          roles: ['admin:memberCollectionPol'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/Polygon/withdrawTransferPol',
        component: () => import('@/views/Polygon/withdrawTransferPol'),
        name: 'withdrawTransferPol',
        meta: {
          title: 'USDT提现转账',
          roles: ['admin:withdrawTransferPol'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/Polygon/polZhuanUsdt',
        component: () => import('@/views/Polygon/polZhuanUsdt'),
        name: 'polZhuanUsdt',
        meta: {
          title: 'USDT转账记录',
          roles: ['admin:polZhuanUsdt'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/Polygon/polCollectionUsdt',
        component: () => import('@/views/Polygon/polCollectionUsdt'),
        name: 'polCollectionUsdt',
        meta: {
          title: 'USDT归集记录',
          roles: ['admin:polCollectionUsdt'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/Polygon/polCollectionPol',
        component: () => import('@/views/Polygon/polCollectionPol'),
        name: 'polCollectionPol',
        meta: {
          title: 'POL归集记录',
          roles: ['admin:polCollectionPol'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      },
      {
        path: '/Polygon/polCollectionOther',
        component: () => import('@/views/Polygon/polCollectionOther'),
        name: 'polCollectionOther',
        meta: {
          title: '其他币种归集记录',
          roles: ['admin:polCollectionOther'],
          icon: 'icon-guanliyuan',
          info: '后台管理员管理',
          keepAlive: true
        }
      }
    ]
  }, 
  // 下级树
  // {
  //   path: '/Tree',
  //   component: Layout,
  //   redirect: '/',
  //   name: '运营管理',
  //   meta: { title: '运营管理', icon: 'el-icon-setting' },
  //   children: [
  //     {
  //       path: '/tree',
  //       component: () => import('@/views/Tree/tree'),
  //       name: 'yifang',
  //       meta: {
  //         title: '下级树',
  //         roles: ['admin:member'],
  //         icon: 'icon-guanliyuan',
  //         info: '后台管理员管理',
  //         keepAlive: false
  //       }
  //     }
  //   ]
  // },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
